import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "@app/core";
import { DiaryHomeComponent } from "@app/view/diary/diary-home/diary-home.component";
import { DiaryDayViewComponent } from "@app/view/diary/diary-day-view/diary-day-view.component";
import { DiaryWeekViewComponent } from "@app/view/diary/diary-week-view/diary-week-view.component";
import { DiaryManagementComponent } from "@app/view/diary/diary-management/diary-management.component";
import { BulkAvailabilityWizardComponent } from "@app/view/diary/bulk-availability-wizard/bulk-availability-wizard.component";

const routes: Routes = [
  {
    path: "diary",
    component: DiaryHomeComponent,
    data: { title: "scheduler.menu.diary" },
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "day",
        pathMatch: "full"
      },
      {
        path: "day",
        component: DiaryDayViewComponent
      },
      {
        path: "week",
        component: DiaryWeekViewComponent
      },
      {
        path: "manage",
        component: DiaryManagementComponent
      },
      {
        path: "bulk",
        component: BulkAvailabilityWizardComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiaryRoutingModule {}
